import {ReactElement} from 'react';
import {ButtonProps} from '@mui/material';
import {CustomTextButton} from './TextButtonStyle';

interface TextButtonProps extends ButtonProps {
  fontSize?: any;
  disabled?: boolean;
}

const TextButton = (props: TextButtonProps): ReactElement => {
  const {variant = 'text', fontSize, disabled = false, ...rest} = props;

  return (
    <CustomTextButton
      fontSize={fontSize}
      {...rest}
      variant={variant}
      disabled={disabled}
    />
  );
};

export default TextButton;
